<template>
  <div>
    <!-- <div class="wp100 p20 rad5" style="border: 1px solid #e4e7ed">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="h40 wp100 disf">
            <p class="fs12 ta-r pr10" style="width: 65px;"></p>
            <el-input
              v-model="searchText"
              placeholder="请输入标题、作者、标签以搜索"
              size="small"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="8">
          <span class="fs12" style="color: #606266">期刊日期：</span>
          <el-date-picker
            v-model="value2"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
          ></el-date-picker>
        </el-col>

        <el-col :span="2">
          <el-button
            type="primary"
            size="small"
            icon="el-icon-search"
            class="h32 lh9 bor1-efefef rad10"
            style="background-color: #15D8CB;"
            >搜索</el-button
          >
        </el-col>
      </el-row>
    </div> -->
    <!-- 期刊 -->
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="《上海教育科研》" name="first">
        <div class="zazhi">
          <el-col :span="4" class="m20" v-for="img in imglist1">
            <el-card shadow="hover" :body-style="{ padding: '0px' }">
              <div class="bor1-b-efefef ">
                <el-image
                  style="width: 100%; "
                  :src="img.src"
                  :fit="fit"
                ></el-image>
                <div class="p10 ta-c h90 bor1-t-e7e7eb ">{{ img.text }}</div>
              </div>
            </el-card>
          </el-col>
        </div>
      </el-tab-pane>
      <el-tab-pane label="《上海教育情报》" name="second">
        <div class=" dis-f fw-w ai-c jc-s">
          <el-col :span="4" class="m20" v-for="imgs in imglist2">
            <el-card shadow="hover" :body-style="{ padding: '0px' }">
              <div class="bor1-b-efefef">
                <el-image
                  style="width: 100%; "
                  :src="imgs.src"
                  :fit="fit"
                ></el-image>
                <div class="p20 ta-c h90 bor1-t-e7e7eb ">{{ imgs.text }}</div>
              </div>
            </el-card>
          </el-col>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-pagination
      background
      active
      layout="prev, pager, next"
      :total="100"
      class="pt20"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "swiper",
  data() {
    return {
      fit: "cover",
      activeName: "first",
      currentDate: new Date(),
      stateTab: 1,
      searchText: "",
      value2: "",
      imglist1: [
        {
          id: 1,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grrcaziaimj607409hwfg02.jpg",
          text: "先探投资周刊 Wealth Invest Weekly 台湾杂志 2021年6月18日",
        },
        {
          id: 2,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1gs43qmydh0j607409hdge02.jpg",
          text: "料理.台湾 Ryori.Taiwan 2021年5月6月",
        },
        {
          id: 3,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grskwiky8dj607409naa702.jpg",
          text: "设计杂志 Shopping Design 台湾 2021年6月",
        },
        {
          id: 4,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grsketr71ij607409twel02.jpg",
          text: "享生活志 小日子 2021年6月",
        },
        {
          id: 5,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grrcazhewuj607409ht9l02.jpg",
          text: "常春藤生活英语 Ivy League Enjoy English 2021年7月",
        },
        {
          id: 1,
          src:
            "https://www.kuaiqikan.com/wp-content/uploads/2018/01/f3a8d9ae860536aa16476f2dd625c84e.jpg",
          text: "上海教育科研",
        },
        {
          id: 2,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1gs43qmydh0j607409hdge02.jpg",
          text: "料理.台湾 Ryori.Taiwan 2021年5月6月",
        },
        {
          id: 3,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grskwiky8dj607409naa702.jpg",
          text: "设计杂志 Shopping Design 台湾 2021年6月",
        },
        {
          id: 4,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grsketr71ij607409twel02.jpg",
          text: "享生活志 小日子 2021年6月",
        },
        {
          id: 5,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grrcazhewuj607409ht9l02.jpg",
          text: "常春藤生活英语 Ivy League Enjoy English 2021年7月",
        },
      ],
      imglist2: [
        {
          id: 1,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grrcazgnm9j607409hq3n02.jpg",
          text: "常春藤解析英語 Ivy League Analytical English 2021年7月",
        },
        {
          id: 2,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grrcazabsfj607409hwf402.jpg",
          text: "天下杂志 Common Wealth 2021年6月16日",
        },
        {
          id: 3,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grskwiky8dj607409naa702.jpg",
          text: "设计杂志 Shopping Design 台湾 2021年6月",
        },
        {
          id: 4,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grrcaza6jaj607409ht9z02.jpg",
          text: "商业周刊 Business Weekly 台湾杂志 2021年6月21日",
        },
        {
          id: 5,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grrcazc8vaj607409haar02.jpg",
          text: "今周刊 Business Today 台湾杂志 2021年6月21日",
        },
        {
          id: 1,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1gr8y57y84oj607409jq3802.jpg",
          text: "英语岛 English Island 台湾杂志 2021年6月",
        },
        {
          id: 2,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1gs43qmydh0j607409hdge02.jpg",
          text: "料理.台湾 Ryori.Taiwan 2021年5月6月",
        },
        {
          id: 3,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grskwiky8dj607409naa702.jpg",
          text: "设计杂志 Shopping Design 台湾 2021年6月",
        },
        {
          id: 4,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grsketr71ij607409twel02.jpg",
          text: "享生活志 小日子 2021年6月",
        },
        {
          id: 5,
          src:
            "http://tva4.sinaimg.cn/large/0084WMXfgy1grrcazhewuj607409ht9l02.jpg",
          text: "常春藤生活英语 Ivy League Enjoy English 2021年7月",
        },
      ],
    };
  },
  mounted() {
    //跳转到指定tab
    this.showtabs();
  },
  methods: {
    handleClick(tab, event) {},

    //跳转我征文页面
    showtabs() {
      if (this.$route.query.activeName != null) {
        this.activeName = this.$route.query.activeName;
        let current1 = this.activeName;
        if (current1 == "second") {
          this.gotolinkMyPeriodical(); //这里写一些跳转后必须要执行的函数
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: white;
  border: 1rpx solid #efefef;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}

.image {
  width: 300px;
  display: block;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}
.chooseSource {
  border-bottom: 2px solid #f93e61;
  color: #f93e61;
}
.stateNum {
  background-color: #f93e61;
}
.el-tab-pane {
  padding: 20px 100px;
}
.flex {
  flex: 1;
  width: 33%;
  min-width: 100%;
  max-width: 100%;
}
.zazhi {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
